import { MYOFunDomain } from '@/components/icons/domains/MYOFunDomain';
import { MYOMentalDomain } from '@/components/icons/domains/MYOMentalDomain';
import { MYOPhysicalDomain } from '@/components/icons/domains/MYOPhysicalDomain';
import { MYOPurposeDomain } from '@/components/icons/domains/MYOPurposeDomain';
import { MYOSocialDomain } from '@/components/icons/domains/MYOSocialDomain';
import { MYOSpiritualDomain } from '@/components/icons/domains/MYOSpiritualDomain';
import { MYOVocationalDomain } from '@/components/icons/domains/MYOVocationalDomain';
import { MYOLogo } from '@/components/icons/domains/MYOLogo';
import { THealthDomainWithOverall } from '@/types/Health.types';

const getDomainIconFromDomain = (domain: THealthDomainWithOverall) => {
  switch (domain) {
    case 'fun':
      return MYOFunDomain;
    case 'mental':
      return MYOMentalDomain;
    case 'physical':
      return MYOPhysicalDomain;
    case 'purpose':
      return MYOPurposeDomain;
    case 'social':
      return MYOSocialDomain;
    case 'spiritual':
      return MYOSpiritualDomain;
    case 'vocational':
      return MYOVocationalDomain;

    case 'overall':
    default:
      return MYOLogo;
  }
};

export default getDomainIconFromDomain;
